import React from 'react';
import {Outlet} from "react-router-dom";

import css from './OrdersPage.module.css';
import {TitleMenuOrders} from "../../components/ordersSection";


const OrdersPage = () => {
    return (
        <section className={css.wrap}>
            <section className={css.menuBlock}>
                <TitleMenuOrders/>
            </section>

            <section className={css.outletBlock}>
                <Outlet/>
            </section>
        </section>
    );
};

export {OrdersPage};